export const ApiEnum = {
    POSTCODE: import.meta.env.REACT_APP_BASE_URL + "/api/v1/postcode",
    GEOCODE: import.meta.env.REACT_APP_BASE_URL + "/api/v1/geocode",
    POSTCODE_AUTO_COMPLETE:
        import.meta.env.REACT_APP_BASE_URL + "/api/v1/postcode/autocomplete",
    DOSSIER: import.meta.env.REACT_APP_BASE_URL + "/api/v1/dossier",
    REGISTRATION_LINK:
        import.meta.env.REACT_APP_BASE_URL + "/api/v1/registration-link",
    EMAIL_ESTABLISHMENT:
        import.meta.env.REACT_APP_BASE_URL +
        "/api/v1/dossier/unknown-contractor/send-mail",
    CARAVAN_SEND_MAIL:
        import.meta.env.REACT_APP_BASE_URL + "/api/v1/dossier/camper/send-mail",
};
